// extracted by mini-css-extract-plugin
export var box = "_3s-0";
export var check = "_3s-1";
export var checkboxButton = "_3s-6";
export var checkboxGroup = "_3s-5";
export var disabled = "_3s-7";
export var ghost = "_3s-9";
export var input = "_3s-2";
export var label = "_3s-4";
export var normal = "_3s-8";
export var uncheck = "_3s-3";